import BaseAlert from 'components/UI/Alerts/BaseAlert';
import React from 'react';
import PropTypes from 'prop-types';

function AlertDanger({
    body,
    onClose,
    onAccept,
    showDialog,
})
{
    const acceptProps = {
        bgColor: 'red',
        text: 'Ok',
        show: true,
    };

    return (
        <BaseAlert
            onClose={onClose}
            onAccept={onAccept}
            showDialog={showDialog}
            acceptProps={acceptProps}
            body={body}
        />
    );
}

AlertDanger.propTypes = {
    showDialog: PropTypes.bool,
    body: PropTypes.node.isRequired,
    onClose: PropTypes.func,
    onAccept: PropTypes.func,
};

export default AlertDanger;
